angular.module('tgaApp').run(['$templateCache', function($templateCache) {
  $templateCache.put('partials/modal_info.html',
    '<div class="popup-background"> <div class="popup-container"> <div class="modal-title">{{ data.title || \'\' }}</div> <div class="modal-body">{{ data.body || \'\' }}</div> <button type="button" class="modal-button" ng-click="actions.submit()" ng-disabled="processing" translate="scenarios.buttons.ok"></button> </div> </div> ');
}]);
